import React from 'react';

import {PlaceholderWrapperComponent} from "../../../placeholder/placeholder-wrapper";

export const PredictionPlaceholderTitle = (props) => {
  return (
    <PlaceholderWrapperComponent className={'prediction-placeholder-title-container'}>
      <div className={'prediction-placeholder-title-content'}>
        <div className={'prediction-placeholder-title'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
